export default "__VITE_ASSET__nI3CDHxu__"